// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608272001/js/" + chunkId + "." + {"44":"df81a997","225":"da700823","481":"b19011ef","486":"a5952d2d","770":"39d97b40"}[chunkId] + ".0.1310186742006042.chunk.js";
};